module.exports = __webpack_public_path__ + "img/btn_used@2x.be90310e.png";